module.exports = __webpack_public_path__ + "static/tags-based-configuration_3-f499d127b164b67a3fef9eab4c900f7e.png";